import React, { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import { withRouter, RouteComponentProps } from "react-router-dom"
import styled from "styled-components"
import { get, getToken, post } from "../../netApi/fetch"
import changeAdmin from "../index/method/changeAdmin"
import { logout, set_login_user_data, waitingLogin, setusertype, saveMallInfo, saveMemberInfo, toggleLoginPanel, setIsHema, setLoginBindInfo } from "../../reducers/index"
import { confirm } from "../Method/Confirm"
import hideTopBarPathList from "../../data/hideTopBarPathList"
import { TOPBAR_HEIGHT } from "../../data/style"
import VIPBar from "./VIPBar"
import VIPPower, { M2G } from "../index/method/VIPPower"
import Login from "./login"

const Background = styled.div`
  /* background: linear-gradient(153deg,#99fea1 8%, #67CAD7 92%); */
  background: white;
  height: 50px;
  z-index: 99;
  position: fixed;
  left: 0;
  width: 100vw;
  top: 0;
  box-sizing: border-box;
  padding: 0 0 0 20px;
  & > :only-child {
    max-width: 1200px;
    margin: 0 auto;
  }
  border-bottom: 1px solid rgb(240 240 240);
`

const Ava = styled.img`
  width: 30px;
  height: 30px;
  border: 2px solid #67cad7;
  border-radius: 50%;
  margin-right: 8px;
`

const LogoutPanel = styled.div`
  color: #fff;
  height: 49px;
  padding-left: 30px;
  padding-right: 30px;
  display: flex;
  align-items: center;
  position: relative;
  transition: background-color 0.3s;
  color: var(--theme-main);
  background-color: #fff;
  border-left: 1px solid rgb(240, 240, 240);
  &:hover {
    background-color: #efefef;
  }
  img {
    position: absolute;
    bottom: -36px;
    right: 18px;
  }
`
const TopButton = styled.button`
  font-size: 16px;
  border: 1px white solid;
  padding: 9px 29px;
  border-radius: 20px;
  color: white;
  line-height: 1;
  background: transparent;
  margin-left: 1rem;
  &:hover {
    opacity: 0.5;
  }
`
const LoginButton = styled(TopButton)`
  color: #fff;
  border: #fff 1px solid;
`

const defaultRes = {
  uid: 1000849186,
  bindsid: "1000849185",
  bind_mall_id: false,
  address_id: 0,
  bind_mall: false,
  bind_shop: {
    id: "1000849185",
    logo: "https://thirdwx.qlogo.cn/mmopen/vi_32/SKqBJeZ12ADbJ5n6UIibjD6VlYhWTR1tYFKpdgk2YTnfibVTWbVprLh9gGV5vFwe36FIU1ich8o334AttsTIibTKnEgtXe6X1RaOxZyTAFbrFg0/132",
    name: "醉于桃李间",
    banner: "https://jieligo-1259536745.picgz.myqcloud.com/uploads/goods/6wVIwMmQw8.jpg",
    is_brand_certification: "0",
    type: 5,
    member_level_info: { start_time: false, end_time: false },
  },
  is_can_use_credit_group: 0,
  member_info: {
    level_type: null,
    member_name: [],
    start_time: false,
    end_time: false,
    residue_day: false,
    rule_list: [
      { rule_type: 5, rule_title: "视频/图片储存空间", use_value: 1, max_value: 0, unit: "M" },
      { rule_type: 1, rule_title: "管理员数量", use_value: "0", max_value: 0, unit: "个" },
      { rule_type: 2, rule_title: "帮卖好友数量", use_value: "0", max_value: 0, unit: "个" },
      { rule_type: 3, rule_title: "免费快递物流查询/月", use_value: 1, max_value: 0, unit: "次" },
    ],
  },
} as const

interface props extends RouteComponentProps {
  user: user
  logout: () => void
  waitingLogin: () => void
  setUserType: (data: any) => void
  login: (data: user) => void
  saveMallInfo: (data?: mall.mallinfo | false) => void
  mallinfo?: mall.mallinfo | false
  memberInfo: member.info
  saveMemberInfo: (data: member.info) => void
  showLogin: (value: boolean) => void
  setIsHema: (value: any) => void
  setLoginBindInfo: (value: loginBindInfo) => void
}

function Top(props: props) {
  const [logoutnav, setLogoutnav] = useState<number>(0)
  // const [logoutnav, setLogoutnav] = useState<number>(Number(localStorage.getItem("logoutnav") || 1))

  const showVIP = useState(false)

  const getting = useRef(false)

  const [alloShow, setAlloShow] = useState(false)
  useEffect(() => {
    if (getting.current) return
    getting.current = true
    if (props.mallinfo === undefined || (props.mallinfo !== false && !props.mallinfo.id)) {
      get("/index/getloginbindinfo", {})
        .then((res) => {
          console.log("res :>> ", res)
          if (res.uid === false) {
            const res = defaultRes as unknown as any
            props.setLoginBindInfo(res)
            props.saveMallInfo(res.bind_mall)
            props.saveMemberInfo(res.member_info)
            props.setIsHema(undefined)
            return
          }
          getting.current = false
          props.setLoginBindInfo(res)
          props.saveMallInfo(res.bind_mall)
          props.saveMemberInfo(res.member_info)
          props.setIsHema(res.is_hema)
        })
        .catch((e) => {
          getting.current = false
        })
    } else {
      getting.current = false
    }
  }, [props])

  if (hideTopBarPathList.find((i) => new RegExp(i).test(props.location.pathname))) {
    return <></>
  }

  const isLogin = props.user && props.user.uid

  return (
    <Background className="flex-between">
      <div style={{ userSelect: "none", pointerEvents: "none" }}>
        <img alt="灵树AI图标" style={{ height: 30, marginTop: "-5px" }} src="/favicon.png" />
        <div style={{ marginLeft: 10, display: "inline-block" }}>
          <span
            style={{
              color: "rgba(52, 52, 52, 1)",
              fontFamily: "Noto Sans SC",
              fontSize: "20px",
              fontWeight: 100,
              lineHeight: "211px",
              letterSpacing: "0px",
              textAlign: "left",
            }}
          >
            灵树AI
          </span>
        </div>
      </div>
      <div className="flex-box" style={{ position: "relative" }}>
        {/* <Admin>
                <i className='iconfont icon-wode-weixuanzhong' />
                <span>管理员</span>
            </Admin> */}
        <Ava
          alt="logo"
          src={isLogin ? props.user.avatar : "/favicon.png"}
          onClick={() => {
            showVIP[1](!showVIP[0])
            get("/god/checkisgod", {}).then((res) => {
              if (res) window.open("https://god.jieligo.net?token=" + getToken())
            })
          }}
        />
        {window.innerWidth >= 1200 && <div style={{ color: isLogin ? "#67CAD7" : "#909090", marginRight: 8 }}>{isLogin ? props.user.name : "游客"}</div>}
        {isLogin && (
          <div
            className="cur-pointer"
            onClick={() => {
              changeAdmin().then((res) => {
                if (res) {
                  props.logout()
                  props.waitingLogin()
                  props.saveMallInfo(undefined)
                  post("/admin/checkIsLogin", {}).then((res) => {
                    post("/proxy/checkProxy", { type: 1 }).then((r) => {
                      props.setUserType(r.type)
                    })
                    props.login(res)
                    props.history.push("/index?refresh=1")
                  })
                }
              })
            }}
            style={{ background: "rgb(255, 255, 255)", color: "rgb(103, 202, 215)", padding: "3px 8px", borderRadius: "20px", border: "0.5px solid rgb(103, 202, 215)" }}
          >
            切换身份
          </div>
        )}
        {/* 取消升级vip */}
        {/* {window.innerWidth >= 1200 && (
          <div style={{ color: "#fff", marginRight: 8 }}>
            <div
              className="cur-pointer"
              onClick={() => {
                VIPPower({ user: props.user })
              }}
              style={{ background: "#fff", color: "#67CAD7", padding: "3px 8px", borderRadius: 3, marginLeft: 8, border: "1px solid #67CAD7" }}
            >
              升级VIP
            </div>
          </div>
        )} */}

        <div style={{ height: 37, borderRight: ".5px solid rgb(240, 240, 240)", margin: "0 0 0 20px", width: 0 }}></div>
        {isLogin ? (
          <LogoutPanel
            onClick={() => {
              confirm({
                text: "请确认退出",
                title: "确认退出登录",
              }).then((res) => {
                if (res) {
                  get("/admin/logout", {
                    openid: props.user.openid,
                  }).then(() => {
                    window.location.replace("/")
                  })
                  props.logout()
                }
              })
            }}
            className="cur-pointer"
          >
            退出登录
            {logoutnav ? (
              <img
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  setLogoutnav(0)
                  localStorage.setItem("logoutnav", "0")
                }}
                src="https://jieligo-1259536745.picgz.myqcloud.com/uploads/content/i0Tyt30HQH.png"
                alt=""
              />
            ) : null}
          </LogoutPanel>
        ) : (
          <LogoutPanel
            onClick={() => {
              showVIP[1](true)
            }}
            className="cur-pointer"
          >
            登录
          </LogoutPanel>
        )}
        {showVIP[0] && (isLogin ? <PropsVip /> : <Login alloShow={showVIP[0]} alloClose={() => showVIP[1](false)} />)}
      </div>
    </Background>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.login_user_data,
    memberInfo: state.member_info,
    mallinfo: state.mallInfo,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    logout: () => {
      dispatch(logout())
    },
    waitingLogin: () => {
      dispatch(waitingLogin())
    },
    setUserType: (v) => {
      dispatch(setusertype(v))
    },
    login: (data) => {
      dispatch(set_login_user_data(true, data))
    },
    saveMallInfo: (data) => {
      dispatch(saveMallInfo(data))
    },
    saveMemberInfo: (data) => {
      dispatch(saveMemberInfo(data))
    },
    showLogin: (b) => {
      dispatch(toggleLoginPanel(b))
    },
    setIsHema: (v) => {
      dispatch(setIsHema(v))
    },
    setLoginBindInfo: (v) => {
      dispatch(setLoginBindInfo(v))
    },
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Top))

const VIPPanel = styled.div`
  width: 280px;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0px 2px 6px 0px #cccccc;
  padding: 16px;
  position: absolute;
  top: ${TOPBAR_HEIGHT}px;
  left: 0px;
  font-size: 12px;
  & > div {
    margin-bottom: 16px;
  }
  &::before {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border: 9px solid transparent;
    border-top: 0;
    border-bottom: 10px solid #fff;
    position: absolute;
    top: -10px;
    left: 6px;
  }
  .bold {
    font-weight: bold;
  }
`
function VIP(props: { memberInfo: member.info; user: user }) {
  const [quotaData, setQuotaData] = useState<any>(null)

  useEffect(() => {
    // 获取配额数据
    get("/content/getquotaoverview", {})
      .then((res) => {
        setQuotaData(res)
      })
      .catch((error) => {
        console.error("获取配额概览失败:", error)
      })
  }, [props])

  let mediaData: member.rule
  if (props.memberInfo && props.memberInfo.rule_list) {
    mediaData = props.memberInfo.rule_list.find((i) => /视频/.test(i.rule_title))
  }
  const medianum = Number(mediaData.max_value) - Number(mediaData.use_value)

  return (
    <VIPPanel>
      <div className="flex-between">
        <div className="flex-center">
          <div className="bold" style={{ fontSize: 14 }}>
            {props.memberInfo?.member_name}
          </div>
          <div style={{ marginLeft: 6 }}>{props.memberInfo?.residue_day ? props.memberInfo.residue_day + "天" : ""}</div>
        </div>
        <div
          className="cur-pointer"
          style={{
            background: "linear-gradient(315deg,#dc9b48 3%, #f1d8af 99%)",
            borderRadius: 3,
            padding: "4px 6px",
          }}
          onClick={() => {
            VIPPower({ user: props.user })
          }}
        >
          升级VIP
        </div>
      </div>
      <div className="bold">VIP等级权益</div>
      {!!mediaData && (
        <>
          <div className="flex-between" style={{ marginBottom: 6 }}>
            <div>
              剩余{M2G(medianum > 0 ? medianum : 0)}/{M2G(Number(mediaData.max_value))}
            </div>
            <div>已使用{((Number(mediaData.use_value) / Number(mediaData.max_value)) * 100).toFixed(2)}%</div>
          </div>
          <div style={{ marginBottom: 6 }}>
            <VIPBar value={(Number(mediaData.use_value) / Number(mediaData.max_value)) * 100} />
          </div>
          <div className="flex-between">
            <div>视频/图片存储空间</div>
            <div
              className="cur-pointer"
              onClick={() => {
                VIPPower({ user: props.user })
              }}
              style={{ color: `var(--theme-main)` }}
            >
              扩容
            </div>
          </div>

          {/* 配额详情：与上方条目样式对齐，使用同级 div 列表以继承 VIPPanel 的间距 */}
          {quotaData && (
            <>
              <div style={{ borderTop: "1px solid #f0f0f0", paddingTop: 12, marginTop: 12 }} />
              <div className="bold" style={{ marginBottom: 8 }}>
                AI笔记配额
              </div>
              {quotaData.daily_note && (
                <div className="flex-between" style={{ fontSize: 12 }}>
                  <div>每日笔记创建</div>
                  <div className="bold">
                    {quotaData.daily_note.limit === "-1" ? (
                      <span style={{ color: "#52c41a" }}>无限</span>
                    ) : (
                      <>
                        <span style={{ color: quotaData.daily_note.remaining > 0 ? "#52c41a" : "#ff4d4f" }}>{quotaData.daily_note.remaining}</span>/{quotaData.daily_note.limit} 条
                      </>
                    )}
                  </div>
                </div>
              )}
              {quotaData.voice_note && (
                <>
                  {!(quotaData.voice_note.monthly_limit_minutes > 0) ? (
                    <div className="flex-between" style={{ fontSize: 12 }}>
                      <div>每日语音笔记</div>
                      <div className="bold">
                        {quotaData.voice_note.daily_limit === "-1" ? (
                          <span style={{ color: "#52c41a" }}>无限</span>
                        ) : (
                          <>
                            <span style={{ color: quotaData.voice_note.daily_remaining > 0 ? "#52c41a" : "#ff4d4f" }}>{quotaData.voice_note.daily_remaining}</span>/{quotaData.voice_note.daily_limit}{" "}
                            条
                          </>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="flex-between" style={{ fontSize: 12 }}>
                      <div>本月语音笔记</div>
                      <div className="bold">
                        {(() => {
                          const totalSeconds = quotaData.voice_note.monthly_limit_minutes * 60
                          const remainingSeconds = totalSeconds - quotaData.voice_note.monthly_used_seconds
                          const remainingMinutes = Math.floor(remainingSeconds / 60)
                          const remainingSecondsOnly = remainingSeconds % 60

                          return (
                            <>
                              <span style={{ color: remainingSeconds > 0 ? "#52c41a" : "#ff4d4f" }}>
                                {remainingMinutes}分{remainingSecondsOnly}秒
                              </span>
                              /{quotaData.voice_note.monthly_limit_minutes}分钟
                            </>
                          )
                        })()}
                      </div>
                    </div>
                  )}
                  {quotaData.voice_note.tip && <div style={{ fontSize: 11, color: "#999", marginTop: 4 }}>💡 {quotaData.voice_note.tip}</div>}
                </>
              )}
              {quotaData.monthly_video && (
                <>
                  {quotaData.monthly_video.monthly_limit_minutes > 0 ? (
                    // VIP用户：正常显示配额
                    <>
                      <div className="flex-between" style={{ fontSize: 12 }}>
                        <div>本月视频生成</div>
                        <div className="bold">
                          {quotaData.monthly_video.monthly_limit_minutes === -1 ? (
                            <span style={{ color: "#52c41a" }}>无限</span>
                          ) : (
                            <>
                              <span style={{ color: quotaData.monthly_video.monthly_remaining_minutes > 0 ? "#52c41a" : "#ff4d4f" }}>{quotaData.monthly_video.monthly_remaining_minutes}</span>/
                              {quotaData.monthly_video.monthly_limit_minutes} 分钟
                            </>
                          )}
                        </div>
                      </div>
                      {quotaData.monthly_video.daily_limit > 0 && (
                        <div className="flex-between" style={{ fontSize: 12, color: "#999" }}>
                          <div>今日可生成</div>
                          <div>
                            <span style={{ color: quotaData.monthly_video.daily_remaining > 0 ? "#52c41a" : "#ff4d4f" }}>{quotaData.monthly_video.daily_remaining}</span>/
                            {quotaData.monthly_video.daily_limit} 条
                          </div>
                        </div>
                      )}
                      {quotaData.monthly_video.tip && <div style={{ fontSize: 11, color: "#999", marginTop: 4 }}>💡 {quotaData.monthly_video.tip}</div>}
                    </>
                  ) : (
                    // 普通用户：灰色显示
                    <>
                      <div className="flex-between" style={{ fontSize: 12 }}>
                        <div style={{ color: "#999" }}>本月视频生成</div>
                        <div style={{ color: "#999" }}>0 分钟</div>
                      </div>
                      {quotaData.monthly_video.is_first_video_free && !quotaData.monthly_video.has_used_free_video && (
                        <div style={{ fontSize: 11, color: "#67CAD7", marginTop: 4 }}>⭐ 首次免费视频体验（最长{quotaData.monthly_video.free_video_max_seconds}秒）</div>
                      )}
                    </>
                  )}
                </>
              )}
            </>
          )}
        </>
      )}
      {props.memberInfo?.rule_list?.map((i) => {
        const num = Number(i.max_value) - Number(i.use_value)
        if (/视频/.test(i.rule_title)) return
        return (
          <div key={i.rule_title} className="flex-between">
            <div>{i.rule_title}</div>
            {Number(i.max_value) === -1 ? (
              <div className="bold">无限</div>
            ) : (
              <div className="bold">
                剩余{num > 0 ? num : 0}/{i.max_value}
                {i.unit}
              </div>
            )}
          </div>
        )
      })}
    </VIPPanel>
  )
}

const PropsVip = withRouter(connect(mapStateToProps, mapDispatchToProps)(VIP))
